import React from 'react';
import ReactDOM from 'react-dom';

import Expandable from '../src/components/expandable';

class FranchiseFaq extends React.Component {
  render() {
    return (
      <div className='component-franchise-faq'>
        <Expandable title='How long will it take to get started in the home inspection industry?'>
          <p>
            You can become a home inspector in as little as three months or as long as one year.
            This will depend on your current knowledge and the time you have available to work on
            becoming a home inspector.
          </p>
        </Expandable>
        <Expandable title='What do I need to do to become a home inspector?'>
          <>
            <p>
              Every home inspector needs to  start by completing the Carson Dunlop (or equivalent)
              home inspection training program. This consists of 10 courses that will take anywhere
              from two to twelve months depending on if you do them full time or part time. After you
              complete your home inspection course you need to join a governing body like InterNACHI or
              OAHI. After joining you will need to complete another test that will test the combined
              knowledge of the ten courses you took through your training program. Once this has been
              completed you need to submit your certificates from InterNachi or OAHI, and Carson Dunlop
              program to our home inspection insurance provider inorder to obtain insurance. You will
              also need to create a sole proprietorship or corporation that you will operate your
              franchise with.
            </p>

            <p>
              If you purchase an Inspec Homes franchise the next step would be purchasing your home
              inspection software and tools. From there you would start to be trained on how to use the
              report writing software, how to perform home inspections, how to market yourself, and create
              your Inspec Homes account and profile on our web application. Inspec Homes will also provide
              assistance with how to register your corporation and execute your franchise agreement. After
              all this you will finally be ready to be a home inspector.
            </p>

            <p>
              The truth is trying to become a home inspector takes a lot of hard work, just like anything
              worth doing. You can do this on your own, but we believe that the value you get working with
              the Inspec Homes team will lead to a faster transition to becoming a home inspector. You will
              make less mistakes, have lower overhead costs associated with creating your own website and brand,
              and a better retirement plan. All these advantages ultimately mean more money in your pocket at
              the end of the day. 
            </p>

            <p>
              Inspec Homes has reimaged the home inspection process from start to finish. By utilizing the
              latest in technology we are able to offer more service and functionality for a lower cost than
              using traditional methods. We offer more online tools to our home inspectors and their clients
              then any one home inspector can provide on their own. 
            </p>
          </>
        </Expandable>
        <Expandable title='What are the obstacles to becoming a home inspector?'>
          <>
            <p>
              There are many obstacles to entry for a new home inspector. These include;
            </p>

            <ul>
              <li>Home Inspector Insurance</li>
              <li>Membership with governing organization like Internachi or Ontario Association of Home Inspectors</li>
              <li>Staying up to date with current news and regulations</li>
              <li>Creating a website</li>
              <li>Deciding what is the best way to collect payment</li>
              <li>Can I accept online payment? Should I buy a machine, what are the costs?</li>
              <li>Marketing yourself to real estate agents</li>
              <li>Marketing yourself online</li>
              <li>Managing your home inspections and staying organized</li>
              <li>Reviewing your data to learn and improve and keep up with changing trends</li>
              <li>Creating contract agreements and so much more</li>
            </ul>

            <p>
              Remember that when you start out as a home inspector you have no training, no website, no brand, no network,
              no business. These things can take years to develop and perfect.  Buying a home inspection franchise with
              Inspec Homes will pay for itself because you will start making money faster, and you will achieve your
              full potential sooner
            </p>
          </>
        </Expandable>
        <Expandable title='How many home inspections will I perform in a year?'>
          <p>
            If a home inspection franchisee is following our system and  working on building their franchise full time you
            typically see 50 to 150 home inspections in year one, 200-250, in year two, and 300 plus by year three. By the
            time a home inspection franchisee becomes a certified master home inspector you can expect to do between 300 - 500
            or more inspections per year at a cost between $375 and $600 per home inspection.
          </p>
        </Expandable>
        <Expandable title='Do you do other types of inspections?'>
          <p>
            Our team of inspectors offer a variety of inspections services including WETT inspections and commercial inspections.
            We start out by training you on home inspections and from there you can take courses and get certified in all types of
            inspections.
          </p>
        </Expandable>
      </div>
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<FranchiseFaq />, document.getElementById('franchise-faq-mount-point'));
})